import {
  getFields,
  getCreatePostStore,
  resetFormFields,
  setCreatePostStore,
} from ".";
import { api, apiRoutes } from "../../api";
import { setPopupStore } from "../../components/ErrorPopup";

export const fetchSubmit = async () => {
  setCreatePostStore({ isLoading: true });
  try {
    const { data, status } = await api.post(apiRoutes.postPost, {
      ...getFields(),
      thumbnail: getCreatePostStore().thumbnail_url,
    });
    if (status == 200) {
      setPopupStore({
        popupMessage: {
          message: JSON.stringify(data?.message),
          type: "success",
        },
      });
      resetFormFields();
    }
  } catch (err: any) {
    setPopupStore({
      popupMessage: {
        message: JSON.stringify(err.response?.data.message) ?? "Some error",
        type: "error",
      },
    });
  } finally {
    setCreatePostStore({ isLoading: false, isVideoUploaded: false });
  }
};
